import { t } from "@/i18n-js/instance";

import { RightActionBlockHeader } from "../RightActionBlockHeader";
import { MarkAsReadButton } from "./MarkAsReadButton";

export const Header = () => (
  <RightActionBlockHeader
    title={t("header_v3.chat_threads")}
    actions={<MarkAsReadButton />}
    className="border-primary border-b"
  />
);
